import { styled } from '@mui/material';

export const CertificatesSectionWrap = styled('div')(() => ({
	display: 'grid',
	gap: '24px',
	gridTemplateColumns: '1fr',
}));
